import IInternationalization from '../../interfaces/internacionalization';

const wordsPt: IInternationalization = {
  'message.cpf_invalid': 'CPF inválido',
};

export default wordsPt;
